export const ASPECT_PRESETS = [
  "",
  "16:9",
  "1.85:1",
  "2:1",
  "2.39:1",
  "2.40:1",
  "2.76:1",
  "custom",
];

export function parseAspectRatio(value) {
  if (typeof value !== "string") return null;
  const match = value.trim().match(/^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?)$/);
  if (!match) return null;
  const width = Number(match[1]);
  const height = Number(match[2]);
  if (!width || !height) return null;
  return width / height;
}

export function previewAspect(preset, custom) {
  if (preset === "custom") return (custom || "").trim();
  if (!preset) return "16:9";
  return preset;
}

/**
 * Centered window, in percentages of the frame, for a target ratio.
 * A wider target crops the top and bottom. A taller target crops the sides.
 */
export function centeredAspectWindow(frameRatio, targetRatio) {
  if (!frameRatio || !targetRatio) {
    return { left: 0, top: 0, width: 100, height: 100 };
  }
  if (targetRatio >= frameRatio) {
    const height = (frameRatio / targetRatio) * 100;
    return {
      left: 0,
      top: (100 - height) / 2,
      width: 100,
      height,
    };
  }
  const width = (targetRatio / frameRatio) * 100;
  return {
    left: (100 - width) / 2,
    top: 0,
    width,
    height: 100,
  };
}

export function sampleFrameTimes(duration, count = 4, random = Math.random) {
  const length = Number(duration);
  const frames = Math.max(0, count);
  if (!Number.isFinite(length) || length <= 0 || frames === 0) return [];
  const start = length * 0.08;
  const end = Math.max(start, length * 0.92);
  const span = end - start;
  const times = [];
  for (let index = 0; index < frames; index += 1) {
    const value = span === 0 ? start : start + random() * span;
    times.push(Math.round(value * 100) / 100);
  }
  return times.sort((a, b) => a - b);
}

export function formatFrameTime(seconds) {
  const total = Math.max(0, Number(seconds) || 0);
  const minutes = Math.floor(total / 60);
  const remain = total - minutes * 60;
  return `${minutes}:${remain.toFixed(1).padStart(4, "0")}`;
}

export function muxThumbnailUrl(playbackId, time) {
  const params = new URLSearchParams({
    time: String(Math.max(0, Number(time) || 0)),
    width: "960",
    fit_mode: "preserve",
  });
  return `https://image.mux.com/${encodeURIComponent(playbackId)}/thumbnail.jpg?${params}`;
}

export function muxStoryboardUrl(playbackId) {
  return `https://image.mux.com/${encodeURIComponent(playbackId)}/storyboard.json`;
}

export async function fetchMuxDuration(playbackId) {
  const response = await fetch(muxStoryboardUrl(playbackId));
  if (!response.ok) {
    throw new Error("Could not read the video length from Mux.");
  }
  const data = await response.json();
  const duration = Number(data?.duration);
  if (!Number.isFinite(duration) || duration <= 0) {
    throw new Error("Could not read the video length from Mux.");
  }
  return duration;
}
